import { render, staticRenderFns } from "./AudioGuide.vue?vue&type=template&id=231d4944&"
import script from "./AudioGuide.vue?vue&type=script&lang=ts&"
export * from "./AudioGuide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports